<template>
  <div class="with-side-panel">
    -
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              Übersicht
            </h6>
          </div>

          <div class="element-box overflow-hidden">

            <h5 class="form-header mb-4">
              Berichtsportale
            </h5>

            <div class="row">
              <!-- 1. Einzelcoaching -->
              <CoachingButton
                  :enabled="companySettings.privateCoachingEnabled"
                  :current-user-role="currentUserRole"
                  :allowed-roles="[
                    'ROLE_ADMIN',
                    'ROLE_COACH',
                    'ROLE_THERAPIST',
                    'ROLE_SITE_SUPPORT',
                    'ROLE_SITE_MANAGER',
                    'ROLE_HEAD_OF_AMDL',
                    'ROLE_PRACTICE_MANAGER',
                    'ROLE_HEAD_OF_MARKETING',
                    'ROLE_ACCOUNTANT',
                    'ROLE_ASSISTANT_VQ'
                  ]"
                  route-name="privateCoachingNewAndActiveList"
                  coaching-type="private"
                  label="Einzelcoaching"/>

              <!-- 2. Gruppenmaßnahmen -->
              <CoachingButton
                  :enabled="companySettings.groupCoachingEnabled"
                  :current-user-role="currentUserRole"
                  :allowed-roles="[
                    'ROLE_ADMIN',
                    'ROLE_COACH',
                    'ROLE_THERAPIST',
                    'ROLE_SITE_SUPPORT',
                    'ROLE_SITE_MANAGER',
                    'ROLE_HEAD_OF_AMDL',
                    'ROLE_PRACTICE_MANAGER',
                    'ROLE_HEAD_OF_MARKETING',
                    'ROLE_ACCOUNTANT',
                    'ROLE_ASSISTANT_VQ'
                  ]"
                  route-name="groupCoachingNewAndActiveList"
                  coaching-type="group"
                  label="Gruppenmaßnahmen"/>

              <!-- 3. Soziotherapie -->
              <CoachingButton
                  :enabled="companySettings.socioTherapyCoachingEnabled"
                  :current-user-role="currentUserRole"
                  :allowed-roles="[
                    'ROLE_ADMIN',
                    'ROLE_COACH',
                    'ROLE_THERAPIST',
                    'ROLE_SITE_SUPPORT',
                    'ROLE_SITE_MANAGER',
                    'ROLE_HEAD_OF_MARKETING',
                    'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',
                    'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY',
                    'ROLE_ACCOUNTANT',
                    'ROLE_ASSISTANT_VQ'
                  ]"
                  route-name="socioTherapyCoachingNewAndActiveList"
                  coaching-type="socioTherapy"
                  label="Soziotherapie"/>

              <!-- 4. Betreutes Wohnen -->
              <CoachingButton
                  :enabled="companySettings.assistedLivingCoachingEnabled"
                  :current-user-role="currentUserRole"
                  :allowed-roles="[
                    'ROLE_ADMIN',
                    'ROLE_COACH',
                    'ROLE_THERAPIST',
                    'ROLE_SITE_SUPPORT',
                    'ROLE_SITE_MANAGER',
                    'ROLE_HEAD_OF_MARKETING',
                    'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',
                    'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY',
                    'ROLE_ACCOUNTANT',
                    'ROLE_ASSISTANT_VQ'
                  ]"
                  route-name="assistedLivingCoachingNewAndActiveList"
                  coaching-type="assistedLiving"
                  label="Betreutes Wohnen"/>

              <!-- 5. DRV Fallmanagement -->
              <CoachingButton
                  :enabled="companySettings.caseManagementCoachingEnabled"
                  :current-user-role="currentUserRole"
                  :allowed-roles="[
                    'ROLE_ADMIN',
                    'ROLE_COACH',
                    'ROLE_THERAPIST',
                    'ROLE_SITE_SUPPORT',
                    'ROLE_SITE_MANAGER',
                    'ROLE_PRACTICE_MANAGER',
                    'ROLE_ACCOUNTANT',
                    'ROLE_ASSISTANT_VQ'
                  ]"
                  route-name="caseManagementCoachingNewAndActiveList"
                  coaching-type="caseManagement"
                  label="DRV Fallmanagement"/>

              <!-- 6. Private Weiterbildung -->
              <CoachingButton
                  :enabled="companySettings.privateLearningCoachingEnabled"
                  :current-user-role="currentUserRole"
                  :allowed-roles="[
                    'ROLE_ADMIN',
                    // 'ROLE_COACH',
                    // 'ROLE_THERAPIST',
                    'ROLE_SITE_SUPPORT',
                    'ROLE_SITE_MANAGER',
                    'ROLE_PRACTICE_MANAGER',
                    'ROLE_HEAD_OF_MARKETING',
                    'ROLE_ACCOUNTANT',
                    'ROLE_ASSISTANT_VQ'
                  ]"
                  route-name="privateLearningCoachingNewAndActiveList"
                  coaching-type="privateLearning"
                  label="Private Weiterbildung"/>
            </div>

          </div>

          <div class="element-box overflow-hidden"
               v-if="
                  companySettings.privateCoachingEnabled && (
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' )">
            <h5 class="form-header mb-4">
              Ausstehendes Coaching
            </h5>
            <div class="row">
              <CoachingButton
                  :enabled="companySettings.privateCoachingEnabled"
                  :current-user-role="currentUserRole"
                  :allowed-roles="[
                    'ROLE_ADMIN',
                    'ROLE_SITE_SUPPORT',
                    'ROLE_SITE_MANAGER',
                    'ROLE_HEAD_OF_AMDL',
                    'ROLE_PRACTICE_MANAGER',
                    'ROLE_HEAD_OF_MARKETING',
                    'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',
                    'ROLE_ACCOUNTANT',
                    'ROLE_ASSISTANT_VQ'
                  ]"
                  route-name="privateCoachingInquiryOverviewList"
                  coaching-type="privateInquiry"
                  label="Einzelcoaching ausstehend"/>
            </div>
          </div>

        </div>
      </div>

      <Sidebar/>
    </div>
  </div>
</template>

<script setup>
import Sidebar from '@/components/FormSidebar.vue';
import {piniaUserStore} from '@/store/piniaUserStore';
import {computed} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import CoachingButton from "@/components/button/CoachingButton.vue";

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
</script>

<style scoped>
</style>